import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Strings } from 'common/utility/string/string';
import { Observable, Subject } from 'rxjs';
import { StorageService } from 'services/storage/storage.service';
import { TokenService } from 'services/token/token.service';
import { Api } from 'src/app/services/http/api-endpoints';
import { Controller } from 'src/app/services/http/interface/controller';
import { Endpoint } from 'src/app/services/http/interface/endpoint';
import { Verb } from './verb';

/*
  Base Http Service for service requests
*/
@Injectable({ providedIn: 'root' })
export class HttpService implements OnDestroy {

  private unsubscribe: Subject<void> = new Subject<void>();

  private static createRoute(controller: Controller, endpoint: Endpoint, parameters: Map<string, string> | null = null): string {

    const separator: string = endpoint.route.startsWith('?') ? Strings.Empty : '/'
    let populatedEndpoint = !!endpoint.route ? `${controller.root}${separator}${endpoint.route}` : controller.root
    if (parameters) {
      parameters.forEach((value: string, key: string) => {
        populatedEndpoint = populatedEndpoint.replace(key, encodeURIComponent(value));
      });
    }
    return `${controller.baseUrl}/${populatedEndpoint}`;
  }

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService,
  ) { }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public submitRequest(controller: Controller, action: string, parameters: Array<string>, body: any = null): Observable<any> {
    const endpoint: Endpoint = Api.getEndpoint(controller, action);
    return this.request(controller, action, Api.createParameters(endpoint.route, parameters), body);
  }

  public request(
    controller: Controller,
    endpointName: string,
    parameters: Map<string, string> | null = null,
    body: any = null,
    headers: HttpHeaders | undefined = undefined
  ): Observable<any> {
    const endpoint: Endpoint = Api.getEndpoint(controller, endpointName);
    const route: string = HttpService.createRoute(controller, endpoint, parameters);
    headers = this.addBearerToken(headers)
    headers = this.addPoolIdHeader(headers)

    switch (endpoint.verb) {
      case Verb.Delete: {
        return this.httpClient.delete(route, { headers: headers })
          // .pipe(
          //   catchError((error: HttpErrorResponse) => {
          //     Logger.error(`Message: '${error.message}' Route: '${route}'`)
          //     return throwError(() => error)
          //   })
          // );
      }

      case Verb.Get: {
        return this.httpClient.get(route, { headers: headers })
          // .pipe(
          //   catchError((error: HttpErrorResponse) => {
          //     Logger.error(`Message: '${error.message}' Route: '${route}'`)
          //     return throwError(() => error)
          //   })
          // );
      }

      case Verb.Patch: {
        return this.httpClient.patch(route, body, { headers: headers })
          // .pipe(
          //   catchError((error: HttpErrorResponse) => {
          //     Logger.error(`Message: '${error.message}' Route: '${route}'`)
          //     return throwError(() => error);
          //   })
          // );
      }

      case Verb.Post: {
        return this.httpClient.post(route, body, { headers: headers })
          // .pipe(
          //   catchError((error: HttpErrorResponse) => {
          //     Logger.error(`Message: '${error.message}' Route: '${route}'`)
          //     return throwError(() => error)
          //   })
          // );
      }

      case Verb.Put: {
        return this.httpClient.put(route, body, { headers: headers })
          // .pipe(
          //   catchError((error: HttpErrorResponse) => {
          //     Logger.error(`Message: '${error.message}' Route: '${route}'`)
          //     return throwError(() => error)
          //   })
          // );
      }
    }
  }

  private addBearerToken(headers: HttpHeaders | undefined): HttpHeaders {
    headers = headers ?? new HttpHeaders()
    if (this.tokenService.valid && this.tokenService.hasAccessToken) {
      headers = headers.set('Authorization', `Bearer ${this.tokenService.AccessToken}`)
    }
    return headers
  }

  private addPoolIdHeader(headers: HttpHeaders | undefined): HttpHeaders {
    headers = headers ?? new HttpHeaders()
    if (!!StorageService.PoolId) {
      headers = headers.set('poolId', StorageService.PoolId)
    }
    return headers
  }

}
